import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Dialog, DialogActions, DialogTitle, Button  } from '@mui/material';
import {FiShoppingCart} from 'react-icons/fi';
import { TbHeadphones } from 'react-icons/tb';
import { HiOutlineClipboardList } from 'react-icons/hi';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { TbLoader } from 'react-icons/tb';
import mainPath from '../utils/path';

const useStyles = makeStyles((theme) => ({    
    myPageBlock:{

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    row:{
        maxWidth:'1280px', 
        margin:'0 auto', 
        padding:'310px 0 0px 0',

        [theme.breakpoints.down(1025)]: {
            padding:'150px 0 0px 0',
        }
    },
    myPageH1:{
        fontSize:'38px',
        textAlign:'center',
        letterSpacing: '-1.9px',
        paddingBottom:'60px',
    },
    myPageListUl:{
        margin:'0 10px',
        display:'flex',
        border:'1px solid #CCC',
        justifyContent:'space-evenly',
        alignItems: 'center',
        padding:'20px',
        height:'168px',
    },
    myPageListLi:{
        flex:'1',
        textAlign:'center',
        borderRight:'1px solid #CCC',
        '&:last-child':{
            borderRight:'none'
        },
    },
    greenIconsUl:{
    
    },
    greenIcons:{
        border:'1px solid #007235',
        borderRadius:'50%',
        width:'40px',
        height:'40px',
        background:'#007235',
        position:'relative',
        margin: '0 auto',
        marginBottom: 5
    },
    icons:{
        color:'#fff',
        fontSize:'25px',
        position:'absolute',
        top:'50%',
        left:'50%',
        transform:'translate(-50%, -50%)',
    },
    recentOrderDiv:{
        margin:'50px 10px',
    },
    pcSpan:{
        marginBottom:'10px',
    },
    recentOrderTableDiv:{
        
    },
    pcDiv:{
        borderTop:'2px solid #007235',
        padding:'10px 0',
        [theme.breakpoints.down(1025)]: {
            display:'none',
        }
    },
    tablethead:{
        
    },
    tabletheadTr:{
        
    },
    tableTh:{
        borderBottom:'2px solid #CCCCCC',
        padding:'10px 0 10px 0',
    },
    tableData:{
        height:'100px',
        textAlign:'center',
    },
    productInformationImg:{
        width:'200px',
        height:'200px',
        marginTop:'20px',
    },
    mobileDiv:{
        display:'none',
        [theme.breakpoints.down(1025)]: {
            display:'block',
        }
    },
    mobileTableDiv:{
        
    },
    mobiletopDiv:{
        display:'flex',
        justifyContent:'space-between',
        borderBottom:'2px solid #ccc',
        borderTop:'2px solid #007235',
        padding:'10px 0',
    },
    mobileContentDiv:{
        display:'flex',
        alignItems:'center',
    },
    mobileproductInformationImg:{
        width:'100px',
        height:'100px',
        margin:'20px 0',
    },
    mobileSpanDiv:{
        paddingLeft:'10px'
    },
    mobileSpan:{
        display:'block',
        margin:'10px 0',
    },
    mobileSpanBorder:{
        padding:'0 5px',
    },
    load:{
        height: 1000,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    },
    loadingIcon:{
        color:'#007235',
        fontSize:'50px',
        animation:'$loadSpin 5s infinite'
    },
    "@keyframes loadSpin":{
        from: { transform:'rotate(0deg)' },
        to: { transform:'rotate(1turn)' }
    },

}))

const MyPageBlock = () => {
    let navigate = useNavigate();
    const theme = useTheme();
    const classes = useStyles(theme);
    const mbId = useSelector(state => state.user.userInfo['mb_id']);
    const login = useSelector(state => state.user.login);

    const [cartCount, setCartCount] = useState(0)
    const [orderCount, setOrderCount] = useState(0)
    const [recentOrder, setRecentOrder] = useState([])
    const [mbPoint, setMbPoint] = useState(0);

    const [dialog, setDialog] = useState('');
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if (!login) {
          navigate("/Login");
        }
    } , [login])

    const getItem = async() => {
        try {
            setLoading(true)
            const res = await axios.post('/api/shop/getMyPage/', {mb_id: mbId})

            if(res.data.success === false) {
                setLoading(false)
                setDialog('불러오기 실패')
                return;
            }
            setCartCount(res.data.cartCount)
            setOrderCount(res.data.orderCount)
            setRecentOrder(res.data.result)
            setMbPoint(res.data.point)
            setLoading(false)
        
          } catch (e) {
            console.log(e)
            setLoading(false)
          }
    }

    useEffect(() => {
        if (mbId) {
            getItem()
        }
    } ,[mbId])

    useEffect(() => {

        return () => {
            setCartCount(0)
            setOrderCount(0)
            setRecentOrder([])
            setMbPoint(0)
        }
      }, [])

    return (
        <div className={classes.myPageBlock}>
        { loading ? (
            <div className={classes.load}>
              <TbLoader className={classes.loadingIcon}/>
            </div>
        ) : (
        <div className={classes.row}>
            <h1 className={classes.myPageH1}>
                {mbId}님
            </h1>
            <div className={classes.myPageListDiv}>
                <ul className={classes.myPageListUl}>
                    <li className={classes.myPageListLi}>
                        <ul className={classes.greenIconsUl}>
                            <li className={classes.greenIcons}>
                                <span className={classes.icons}>P</span>
                            </li>
                            <li>포인트</li>
                            <li
                                style={{fontWeight: 'bold'}}
                            >
                                {mbPoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} P
                            </li>
                        </ul>
                    </li>
                    <li className={classes.myPageListLi}>
                        <ul>
                            <li 
                                className={classes.greenIcons}
                                onClick={() => {
                                    navigate("/Cart");
                                }}
                                style={{cursor: 'pointer'}}
                            >
                                <FiShoppingCart className={classes.icons}/>
                            </li>
                            <li>장바구니</li>
                            <li
                                style={{fontWeight: 'bold'}}
                            >
                                {cartCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}개
                            </li>
                        </ul>
                    </li>
                    <li className={classes.myPageListLi}>
                        <ul>
                            <li 
                                className={classes.greenIcons}
                                onClick={() => {
                                    navigate("/OrderList");
                                }}
                                style={{cursor: 'pointer'}}
                            >
                                <HiOutlineClipboardList className={classes.icons}/>
                            </li>
                            <li>주문내역</li>
                            <li
                                style={{fontWeight: 'bold'}}
                            >
                                {orderCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}개
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className={classes.recentOrderDiv}>
                <span style={{fontWeight: 'bold'}} className={classes.pcSpan}>최근주문내역</span>
                <div className={classes.recentOrderTableDiv}>
                    <table className={classes.pcDiv}>
                        <thead className={classes.tablethead}>
                            <tr className={classes.tabletheadTr}>
                                <th className={classes.tableTh}>상품정보</th>
                                <th className={classes.tableTh}>주문일자</th>
                                <th className={classes.tableTh}>주문번호</th>
                                <th className={classes.tableTh}>주문금액</th>
                                <th className={classes.tableTh}>주문상태</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recentOrder.length > 0 && recentOrder.map(item => (
                                <OrderItm 
                                    key={item['od_id']}
                                    odId={item['od_id']}
                                    odCartPrice={item['od_cart_price']}
                                    odStatus={item['od_status']}
                                    odTime={item['od_time']}
                                    itName={item['it_names'][0]}
                                    itImg={item['it_imgs'][0]}
                                />
                            ))}
                        </tbody>
                    </table>
                    <div className={classes.mobileDiv}>
                        <div className={classes.mobileTableDiv}>
                            {recentOrder.length > 0 && recentOrder.map( (result, idx) => {
                                return(
                                    <div key={idx}>
                                        <div className={classes.mobiletopDiv}>
                                            <span>
                                                {result['od_time'] && result['od_time'].substr(0, 10)}
                                            </span>
                                            <span>
                                                {result['od_id']}
                                            </span>
                                        </div>
                                        <div className={classes.mobileContentDiv}>
                                            <img 
                                                src={`${mainPath}/media/data/item/${result['it_imgs']}`}
                                                className={classes.mobileproductInformationImg}
                                            />
                                            <div className={classes.mobileSpanDiv}>
                                                <span className={classes.mobileSpan}>
                                                    {result['it_names']}
                                                </span>
                                                <span className={classes.mobileSpan}>
                                                    {result['od_cart_price'] && result['od_cart_price'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
                                                </span>
                                                <span className={classes.mobileSpan}>
                                                    <span 
                                                        className={classes.mobileSpanBorder}
                                                        style={{ 
                                                            color: result['od_status'] === "완료" && "#fff", 
                                                            background: result['od_status'] === "완료" && "#80BA41", 
                                                            borderRadius:result['od_status'] === "완료" && "5px" 
                                                        }}
                                                    >
                                                        {result['od_status'] }
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        ) }

            <Dialog
                open={dialog === '' ? false : true}
                onClose={() => setDialog('')}
            >
                <DialogTitle id="alert-dialog-title">
                {dialog}
                </DialogTitle>
                <DialogActions>
                <Button onClick={() => setDialog('')} autoFocus>
                    확인
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}


const OrderItm = ({
                odId,
                odCartPrice,
                odStatus,
                odTime,
                itName,
                itImg}) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    let navigate = useNavigate();

    return(
        <tr className={classes.tableData}>
            <td>
                <ul>
                    <li
                        onClick={() => {
                            navigate("/OrderListDetail", {
                                state: { odId: odId }
                            });
                        }}
                        style={{cursor: 'pointer'}}
                    >
                        <img 
                            src={`${mainPath}/media/data/item/${itImg}`}
                            className={classes.productInformationImg}
                        />
                    </li>
                    <li>{itName}</li>
                </ul>
            </td>
            <td>
                {odTime.substr(0, 10)}
            </td>
            <td>
                {odId}
            </td>
            <td>
                {odCartPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원
            </td>
            <td>
                
                <span 
                    className={classes.mobileSpanBorder}
                    style={{ 
                        color: odStatus === "완료" && "#fff", 
                        background: odStatus === "완료" && "#80BA41", 
                        borderRadius: odStatus === "완료" && "5px" 
                    }}
                >
                    {odStatus}
                </span>
            </td>
        </tr>
    )
}


export default MyPageBlock;